module.exports = __webpack_public_path__ + "img/p1_bg.763ce9ff.jpg";